import { Select } from '../ui';
import type { Role } from '../../lib/api/access.gen';

// RoleSelect (P01 §4.3) — pick a member's role. Shows only roles of the member's
// kind (a client membership can never hold a staff role, and vice versa, §5).
// (The richer AnchoredPanel pill with member counts is a later refinement; a
// native Select is the accessible baseline.)
interface RoleSelectProps {
  roles: Role[];
  kind: 'staff' | 'client';
  value: string | undefined;
  disabled?: boolean;
  onChange: (roleId: string) => void;
}

export function RoleSelect({ roles, kind, value, disabled, onChange }: RoleSelectProps): JSX.Element {
  const options = roles.filter((r) => r.kind === kind);
  return (
    <Select
      value={value ?? ''}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      aria-label="Role"
      className="min-w-[10rem]"
    >
      <option value="" disabled>
        Select a role…
      </option>
      {options.map((role) => (
        <option key={role.id} value={role.id}>
          {role.name}
          {role.isSystem ? '' : ' (custom)'}
        </option>
      ))}
    </Select>
  );
}
